import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HoverOutsideDirective } from 'app/shared/directives/hover-outside/hover-outside.directive';
import { MousedownOutsideDirective } from 'app/shared/directives/mousedown-outside/mousedown-outside.directive';
import { LibDirectivesModule } from '@wind-log_library/fe-component-library';
import { VarDirective } from './local-variable/local-variable.directive';
import { ScrollIntoViewDirective } from './scroll-into-view/scroll-into-view.directive';

const DIRECTIVES = [
  HoverOutsideDirective,
  MousedownOutsideDirective,
  VarDirective,
  ScrollIntoViewDirective
];

@NgModule({
  imports: [
    CommonModule,
    LibDirectivesModule
  ],
  declarations: DIRECTIVES,
  providers: [],
  exports: [...DIRECTIVES, LibDirectivesModule]
})

export class DirectivesModule {
}
